// ============================================
// Google Haritalarda Reklam Verme - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleHaritalardaReklamVermeContent: BlogContent = {
  tableOfContents: [
    { id: "yerel-reklamlar", title: "Yerel Reklamlar" },
    { id: "kampanya-tipleri", title: "Kampanya Tipleri" },
    { id: "performans-takibi", title: "Performans Takibi" },
    { id: "case-study", title: "Case Study" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google Haritalarda reklam verme</strong> stratejileri ve performans optimizasyonu."
    }
  ]
};

export default googleHaritalardaReklamVermeContent;
